// Affichage d'une puissance dans l'unité qui la rend lisible : en dessous de 1 kW en watts
// (« 3 W » plutôt que « 0,00 kW »), au-delà en kilowatts.

export interface PowerDisplay {
  value: number;
  unit: 'W' | 'kW';
  decimals: number;
}

/** Valeur, unité et décimales pour une puissance donnée en kW. */
export function powerDisplay(kw: number): PowerDisplay {
  if (Math.abs(kw) < 1) return { value: kw * 1000, unit: 'W', decimals: 0 };
  return { value: kw, unit: 'kW', decimals: kw < 10 ? 2 : 1 };
}

/** Texte prêt à afficher, ex. « 3 W », « 1,25 kW ». */
export function formatPower(kw: number, locale: string): string {
  const d = powerDisplay(kw);
  return `${d.value.toLocaleString(locale, { minimumFractionDigits: d.decimals, maximumFractionDigits: d.decimals })} ${d.unit}`;
}

/** Arrondi « rond » vers le haut (1, 2, 5 × 10ⁿ) pour le maximum d'une jauge. */
export function niceCeil(v: number): number {
  if (v <= 0) return 1;
  const p = Math.pow(10, Math.floor(Math.log10(v)));
  for (const m of [1, 2, 5, 10]) if (v <= m * p) return m * p;
  return 10 * p;
}
